import { useAppContext } from '@contexts/AppContext';
import { useCachedNavProfile } from '@utils/cache';
import { useIsClient } from '@utils/common';
import { Header } from '@components/Header';

import { useHeaderBasketQuery } from './gql/graphql.v4.generated';
import { useHeaderCatalogTreeQuery, useHeaderUserQuery } from './gql/graphql.v3.generated';

interface Props {
  isMobileBottomBarEnabled?: boolean,
}

export const HeaderContainer: React.FC<Props> = ({
  isMobileBottomBarEnabled,
}) => {
  const isClient = useIsClient();

  const { isBot } = useAppContext();

  const [cacheData, setCacheData] = useCachedNavProfile();

  const {
    data: catalogTreeData,
    loading: catalogTreeLoading,
  } = useHeaderCatalogTreeQuery({
    context: {
      batch: true,
    },
    skip: !isBot && !isClient,
  });

  const {
    data: userData,
    loading: userLoading,
  } = useHeaderUserQuery({
    context: {
      batch: true,
      ignoreAuthError: true,
    },
    skip: !isClient,
    onCompleted: ({ viewer }) => {
      if (viewer) {
        setCacheData({
          ...(cacheData || {}),
          viewer,
        });
      }
    },
    onError: () => setCacheData(undefined),
  });

  const { data: basketData } = useHeaderBasketQuery({
    context: {
      batch: true,
      ignoreAuthError: true,
      v4: true,
    },
    skip: !isClient,
    onCompleted: ({ basket }) => {
      if (basket) {
        setCacheData({
          ...(cacheData || {}),
          basket,
        });
      }
    },
  });

  return (
    <Header
      user={userData?.viewer || cacheData?.viewer}
      productsCount={basketData?.basket.productsCount || cacheData?.basket?.productsCount}
      catalogTreeJSON={catalogTreeData?.catalogTree?.catalogTree}
      isUserLoading={userLoading}
      isCatalogTreeLoading={catalogTreeLoading}
      isMobileBottomBarEnabled={isMobileBottomBarEnabled}
    />
  );
};

export default HeaderContainer;
